import TablaBoletines from '../tablas/TablaBoletines.js';
import CamposBoletinesPersona from '../campos/CamposBoletinesPersona.js';

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaBoletines
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  // Ordenar por fechaHasta si existe, sino por fecha del boletin
  const fechaA = itemA.fechaHasta
    ? new Date(itemA.fechaHasta).getTime()
    : itemA.boletin
      ? (itemA.boletin.anioBoletin || 0) * 10_000 +
        (itemA.boletin.mesBoletin || 0) * 100 +
        (itemA.boletin.diaBoletin || 0)
      : 0;
  const fechaB = itemB.fechaHasta
    ? new Date(itemB.fechaHasta).getTime()
    : itemB.boletin
      ? (itemB.boletin.anioBoletin || 0) * 10_000 +
        (itemB.boletin.mesBoletin || 0) * 100 +
        (itemB.boletin.diaBoletin || 0)
      : 0;
  return fechaA - fechaB;
};

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange) => {
  return (
    <CamposBoletinesPersona
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  if (!item) return item;
  switch (campo) {
    case 'boletin': {
      return { ...item, boletin: valor };
    }
    case 'tipoPaseBoletin': {
      return { ...item, tipoPaseBoletin: valor };
    }
    case 'fechaHasta': {
      return { ...item, fechaHasta: valor };
    }
    case 'tipoObjetoOrigen': {
      return { ...item, tipoObjetoOrigen: valor, idOrigen: null, origen: null };
    }
    case 'idOrigen': {
      if (!valor) return { ...item, idOrigen: null, origen: null };
      return { ...item, idOrigen: valor.id ? valor.id : valor, origen: valor };
    }
    case 'tipoObjetoDestino': {
      return { ...item, tipoObjetoDestino: valor, idDestino: null, destino: null };
    }
    case 'idDestino': {
      if (!valor) return { ...item, idDestino: null, destino: null };
      return { ...item, idDestino: valor.id ? valor.id : valor, destino: valor };
    }
    case 'observacion': {
      return { ...item, observacion: valor };
    }
    case 'dudas': {
      return { ...item, dudas: valor };
    }
    default: {
      return item;
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para el boletín';
  } else if (!item.boletin || !item.boletin.id) {
    error = 'Debe seleccionar un boletín';
  }
  return error;
};
